import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconIceHockey: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconIceHockey"><Path d="M22.5 9.29167C22.5 11.3857 17.799 13.0833 12 13.0833C6.20101 13.0833 1.5 11.3857 1.5 9.29167M22.5 9.29167C22.5 7.19759 17.799 5.5 12 5.5C6.20101 5.5 1.5 7.19759 1.5 9.29167M22.5 9.29167V14.7083C22.5 16.8024 17.799 18.5 12 18.5C6.20101 18.5 1.5 16.8024 1.5 14.7083V9.29167" stroke="currentColor"/></CentralIconBase>;
});

export default IconIceHockey;
